import React, { useState } from "react";
import SideBar from "../../components/sidebar/Sidebar";
import "./HomePage.scss";
import ServerSidePaginationTable from "../../components/shared/ServerSidePaginationTable";
import { Box } from "@mui/material";
import { PersonaFisicaModel } from "../../models/PersonaFisicaModel";
import { AxiosError } from "axios";
import {
  fetchContractsQueryKey,
  fetchCustomersQueryKey,
  fetchGoodConditionQueryKey,
  fetchGoodSubCategoryQueryKey,
} from "../../utils/QueryClient";
import { fromAxiosErrorToMessage } from "../../utils/crud";
import { ContrattoModel } from "../../models/ContrattoModel";
import DeferredSearchSelect from "../../components/shared/DeferredSearchSelect";
import { BeneSottoTipologiaModel } from "../../models/api/response/bene/BeneSottoTipologiaModel";
import { CondizioneModel } from "../../models/CondizioneModel";
import {
  fetchContracts,
  fetchCustomers,
  fetchGoodCondition,
  fetchGoodSubCategories,
} from "../../api/dashboard-filter";
import { BeneContrattoModel } from "../../models/BeneContrattoModel";
import DeferredTextField from "../../components/shared/DeferredTextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/it";

const HomePage: React.FC<{}> = () => {
  const [customerId, setCustomerId] = useState<string>("");
  const [contractId, setContractId] = useState<string>("");
  const [goodSubCategoryId, setGoodSubCategoryId] = useState<string>("");
  const [goodConditionId, setGoodConditionId] = useState<string>("");

  const [contractTitle, setContractTitle] = useState<string>("");
  const [goodSubCategory, setGoodSubCategory] = useState<string>("");
  const [goodCondition, setGoodCondition] = useState<string>("");
  const [sellingNotes, setSellingNotes] = useState<string>("");
  const [saleDate, setSaleDate] = useState<Dayjs | null>(null);
  const [saleDateEnd, setSaleDateEnd] = useState<Dayjs | null>(null);

  const [hideError, setHideError] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>("");

  return (
    <div className="home">
      <SideBar />
      <div className="homeContainer">
        <>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            sx={{ marginTop: "10pt", marginBottom: "10pt", gap: "10px" }}
          >
            <DeferredSearchSelect
              label={"Cliente Associato"}
              labelPresentation={(option: PersonaFisicaModel) =>
                `${option.nome} ${option.cognome}`
              }
              searchQueryKey={fetchCustomersQueryKey}
              searchFunction={(term) => fetchCustomers(term)}
              onChange={(newInputValue: PersonaFisicaModel | null) => {
                setCustomerId(newInputValue?.id_cliente.toString() || "");
              }}
              onError={(error: AxiosError<unknown, any>) => {
                setHideError(false);
                setErrorMessage(fromAxiosErrorToMessage(error));
              }}
            />

            <DeferredSearchSelect
              label={"Titolo Contratto"}
              labelPresentation={(option: ContrattoModel) => `${option.titolo}`}
              searchQueryKey={fetchContractsQueryKey}
              searchFunction={(title) => fetchContracts(title, customerId)}
              onChange={(newInputValue: ContrattoModel | null) => {
                setContractTitle(newInputValue?.titolo || "");
                setContractId(newInputValue?.id.toString() || "");
              }}
              onError={(error: AxiosError<unknown, any>) => {
                setHideError(false);
                setErrorMessage(fromAxiosErrorToMessage(error));
              }}
            />
            <DeferredSearchSelect
              label={"Sotto-Categoria Bene"}
              labelPresentation={(option: BeneSottoTipologiaModel) =>
                `${option.nome}`
              }
              searchQueryKey={fetchGoodSubCategoryQueryKey}
              searchFunction={(name) =>
                fetchGoodSubCategories(
                  name,
                  customerId,
                  contractId,
                  goodConditionId
                )
              }
              onChange={(newInputValue: BeneSottoTipologiaModel | null) => {
                setGoodSubCategory(newInputValue?.nome || "");
                setGoodSubCategoryId(newInputValue?.id.toString() || "");
              }}
              onError={(error: AxiosError<unknown, any>) => {
                setHideError(false);
                setErrorMessage(fromAxiosErrorToMessage(error));
              }}
            />
            <DeferredSearchSelect
              label={"Condizione Bene"}
              labelPresentation={(option: CondizioneModel) => `${option.nome}`}
              searchQueryKey={fetchGoodConditionQueryKey}
              searchFunction={(name) =>
                fetchGoodCondition(
                  name,
                  customerId,
                  contractId,
                  goodSubCategoryId
                )
              }
              onChange={(newInputValue: CondizioneModel | null) => {
                setGoodCondition(newInputValue?.nome || "");
                setGoodConditionId(newInputValue?.id.toString() || "");
              }}
              onError={(error: AxiosError<unknown, any>) => {
                setHideError(false);
                setErrorMessage(fromAxiosErrorToMessage(error));
              }}
            />
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            sx={{ marginBottom: "10pt", gap: "10px" }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
              <DatePicker
                label="Data Vend. Iniz."
                value={saleDate}
                onChange={(newValue) => setSaleDate(newValue)}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                  },
                  field: { clearable: true },
                }}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
              <DatePicker
                label="Data Vend. Fin."
                value={saleDateEnd}
                onChange={(newValue) => setSaleDateEnd(newValue)}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                  },
                  field: { clearable: true },
                }}
              />
            </LocalizationProvider>
            <DeferredTextField
              label={"Note di Vendita"}
              onChange={(e) => setSellingNotes(e)}
            />
          </Box>
        </>
        <ServerSidePaginationTable
          customer_id={customerId}
          contract_title={contractTitle}
          good_sub_category={goodSubCategory}
          good_condition={goodCondition}
          good_selling_notes={sellingNotes}
          sale_date={saleDate ? saleDate.format("YYYY-MM-DD") : ""}
          sale_date_end={saleDateEnd ? saleDateEnd.format("YYYY-MM-DD") : ""}
        />
      </div>
    </div>
  );
};

export default HomePage;
